/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CouponData
 */
export interface CouponData {
    /**
     * 
     * @type {string}
     * @memberof CouponData
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof CouponData
     */
    amountNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponData
     */
    amountGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CouponData
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CouponData
     */
    turnoverGross?: MoneyOutput;
}

/**
 * Check if a given object implements the CouponData interface.
 */
export function instanceOfCouponData(value: object): value is CouponData {
    return true;
}

export function CouponDataFromJSON(json: any): CouponData {
    return CouponDataFromJSONTyped(json, false);
}

export function CouponDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponData {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'amountNet': json['amountNet'] == null ? undefined : json['amountNet'],
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
    };
}

export function CouponDataToJSON(json: any): CouponData {
    return CouponDataToJSONTyped(json, false);
}

export function CouponDataToJSONTyped(value?: CouponData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'amountNet': value['amountNet'],
        'amountGross': value['amountGross'],
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
    };
}

